import React from "react";
import { RedWave } from "@/components/RedWave";

const ROWS = [
  { a: "Jitters", b: "Smooth Energy" },
  { a: "Crash", b: "Sustained Focus" },
  { a: "Anxiety", b: "Calm Clarity" },
  { a: "Shaky hands", b: "Steady Flow" },
];

export default function Difference() {
  return (
    <section
      id="difference"
      data-testid="difference-section"
      className="relative py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <span className="text-[10px] tracking-[0.32em] uppercase text-[color:var(--fs-gold-muted)]">
              02 / The Difference
            </span>
            <h2
              className="mt-5 font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-white"
              data-testid="difference-heading"
            >
              Not Your
              <br />
              <span className="italic text-gold-foil">Regular Coffee.</span>
            </h2>
            <p className="mt-8 text-neutral-400 text-base leading-relaxed max-w-md">
              Most coffee spikes your energy — then drops it. Flow State is
              designed to keep you steady, clear, and locked in for hours.
            </p>
            <div className="mt-10 w-40 opacity-80">
              <RedWave className="w-full h-8" strokeWidth={1.5} />
            </div>
          </div>

          {/* Comparison table */}
          <div className="lg:col-span-7">
            <div className="card-gold p-0 rounded-[2px] overflow-hidden">
              <div className="grid grid-cols-2 text-[10px] tracking-[0.28em] uppercase">
                <div className="px-6 md:px-8 py-5 text-neutral-500 border-r border-[color:var(--fs-hairline)]">
                  Regular Coffee
                </div>
                <div className="px-6 md:px-8 py-5 text-[color:var(--fs-gold-hi)]">
                  Flow State
                </div>
              </div>
              <div className="hairline-gold" />
              {ROWS.map((r, i) => (
                <div
                  key={r.a}
                  className={`grid grid-cols-2 ${
                    i !== ROWS.length - 1
                      ? "border-b border-[color:var(--fs-hairline)]"
                      : ""
                  }`}
                  data-testid={`difference-row-${i}`}
                >
                  <div className="px-6 md:px-8 py-6 font-display text-xl md:text-2xl text-neutral-500 line-through decoration-[0.5px] decoration-neutral-700 border-r border-[color:var(--fs-hairline)]">
                    {r.a}
                  </div>
                  <div className="px-6 md:px-8 py-6 font-display text-xl md:text-2xl text-white flex items-center gap-3">
                    <span className="h-[1px] w-4 bg-[color:var(--fs-gold-muted)]" />
                    {r.b}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
